__turbopack_context__.v({
  "container": "styles-module__UTvT4W__container",
  "numbersContainer": "styles-module__UTvT4W__numbersContainer",
});
